function Berge() {
  return (
    <>
      <div className="wuste-wrapper versteckt">
        <div className="heuball">
          <div className="heuball__dorne heuball__dorne--1"></div>
          <div className="heuball__dorne heuball__dorne--2"></div>
          <div className="heuball__dorne heuball__dorne--3"></div>
          <div className="heuball__dorne heuball__dorne--4"></div>
          <div className="heuball__dorne heuball__dorne--5"></div>
          <div className="heuball__dorne heuball__dorne--6"></div>
          <div className="heuball__dorne heuball__dorne--7"></div>
          <div className="heuball__dorne heuball__dorne--8"></div>
          <div className="heuball__dorne heuball__dorne--9"></div>{" "}
          <div className="heuball__dorne heuball__dorne--5"></div>
          <div className="heuball__dorne heuball__dorne--10"></div>
          <div className="heuball__dorne heuball__dorne--11"></div>
          <div className="heuball__dorne heuball__dorne--12"></div>
          <div className="heuball__inner heuball__inner--1"></div>
          <div className="heuball__inner heuball__inner--2"></div>
          <div className="heuball__stock"></div>
        </div>
        <div className="heuball heuball--2">
          <div className="heuball__dorne heuball__dorne--1"></div>
          <div className="heuball__dorne heuball__dorne--2"></div>
          <div className="heuball__dorne heuball__dorne--3"></div>
          <div className="heuball__dorne heuball__dorne--4"></div>
          <div className="heuball__dorne heuball__dorne--5"></div>
          <div className="heuball__dorne heuball__dorne--6"></div>
          <div className="heuball__dorne heuball__dorne--7"></div>
          <div className="heuball__dorne heuball__dorne--8"></div>
          <div className="heuball__dorne heuball__dorne--9"></div>{" "}
          <div className="heuball__dorne heuball__dorne--5"></div>
          <div className="heuball__dorne heuball__dorne--10"></div>
          <div className="heuball__dorne heuball__dorne--11"></div>
          <div className="heuball__dorne heuball__dorne--12"></div>
          <div className="heuball__inner heuball__inner--1"></div>
          <div className="heuball__inner heuball__inner--2"></div>
          <div className="heuball__stock"></div>
        </div>
        <div className="schadel schadel--1">
          <div className="schadel-augen"></div>
          <div className="schadel-nase"></div>
        </div>
        <div className="schadel schadel--2">
          <div className="schadel-augen"></div>
          <div className="schadel-nase"></div>
        </div>
        <div className="schadel schadel--3">
          <div className="schadel-augen"></div>
          <div className="schadel-nase"></div>
        </div>
        <div className="knochen knochen--1"></div>
        <div className="knochen knochen--2"></div>
        <div className="knochen knochen--3"></div>
        <div className="knochen knochen--4"></div>
      </div>

      <div className="berge berge--1">
        <div className="berge__rissen"></div>
      </div>
      <div className="berge berge--2">
        <div className="berge__rissen"></div>
      </div>
      <div className="berge berge--3">
        <div className="berge__rissen"></div>
      </div>
    </>
  );
}

export default Berge;
